import React from "react";
import { TextField } from "@mui/material";
import GroupAllUsers from "../FieldTags/GroupAllUsers";
import pullListLabels from "../../util/PullListLabels";
import HistoryLogElement from "./HistoryLogElement";

const NumberOfSamples = ({ numberOfSamples, handleChange, pullLists }) => {
    return (
        <div className="planField">
            <GroupAllUsers />
            <TextField
                id="numberOfSamples-field"
                name="numberOfSamples"
                label={pullListLabels.numberOfSamples}
                InputLabelProps={{ shrink: true }}
                type="text"
                value={numberOfSamples ? numberOfSamples : ""}
                onChange={(e) => handleChange("numberOfSamples", e.target.value)}
                className="fullLength"
            />
            <HistoryLogElement pullLists={pullLists} label={"numberOfSamples"} />
        </div>
    );
};

export default NumberOfSamples;